import { useParams } from "react-router-dom";
import { GetServerParsedName } from "../../../../../Services/Servers/ServerHelper";

const HeaderServerName = ({GetServer}) => {
    const { serverId } = useParams();

    const server = GetServer(serverId);

    if(server == null)
        return (<></>);

    return(
        <div class="currentServerSection center-x">
            <span className="mobile-disabled">Obecnie przeglądasz:</span>
            <div className="currentServer center-x">
                <span className="currentServerName" dangerouslySetInnerHTML={{__html: GetServerParsedName(server.name)}}></span>
            </div>
        </div>
    );
}

export default HeaderServerName;